import React from 'react';
import { CurrentHouseProvider } from '@/context/CurrentHouseContext';
import StagedDocumentsPage from '@/components/staged-documents/StagedDocumentsPage';
import WithPropertyRole from '@/components/WithPropertyRole';
import { Permission } from '@/utils/permissionUtils';

/**
 * The staged-documents review queue for one property.
 *
 * The API admits Owner and Admin only: a Contributor may stage a file through a key and never
 * decide about one. `HOUSE_DOCUMENT_SHARE_RESOLVE` is that population as the server publishes it
 * — it is the permission for accepting a document pushed in from outside, which is the same
 * decision about the same kind of arrival — so the role rule stays the server's rather than being
 * restated here.
 */
const StagedDocuments: React.FC = () => (
	<CurrentHouseProvider>
		<WithPropertyRole requiredPermissions={[Permission.HOUSE_DOCUMENT_SHARE_RESOLVE]}>
			<StagedDocumentsPage />
		</WithPropertyRole>
	</CurrentHouseProvider>
);

export const Route = createFileRoute({
	component: StagedDocuments,
});
